import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonBoxStyled,
  TitleButtonBoxStyled,
  ButtonBoxContentStyled,
  ButtonStyled as Button,
} from './styles/ButtonBoxStyled';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';
import { GoogleTagManager } from '../../../helpers';

const ButtonBox = ({
  icon,
  title,
  text,
  buttonText,
  buttonColor,
  startIconButton,
  endIconButton,
  urlRedirect,
  variantButton,
  markOptions,
}) => {
  return (
    <ButtonBoxStyled>
      <TitleButtonBoxStyled>
        {icon}
        <h1>{title}</h1>
      </TitleButtonBoxStyled>
      <ButtonBoxContentStyled>
        {text}
        <Button
          onClick={() => {
            redirectInternalOrExternal(urlRedirect);
            if (markOptions) {
              GoogleTagManager.pushToDataLayer(markOptions);
            }
          }}
          color={buttonColor}
          startIcon={startIconButton}
          endIcon={endIconButton}
          variant={variantButton}
        >
          {buttonText}
        </Button>
      </ButtonBoxContentStyled>
    </ButtonBoxStyled>
  );
};

const markPropsShape = PropTypes.shape({
  event: PropTypes.string,
  page: PropTypes.string,
  pagename: PropTypes.string,
});

ButtonBox.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  buttonText: PropTypes.string.isRequired,
  startIconButton: PropTypes.node,
  endIconButton: PropTypes.node,
  urlRedirect: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  variantButton: PropTypes.string,
  markOptions: markPropsShape,
};

ButtonBox.defaultProps = {
  startIconButton: null,
  endIconButton: null,
  variantButton: null,
  markOptions: null,
};

export default ButtonBox;
